import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";
import { MapsComponent } from "./views/admin/maps/maps.component";
import { SettingsComponent } from "./views/admin/settings/settings.component";
import { TablesComponent } from "./views/admin/tables/tables.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { ProfileComponent } from "./views/profile/profile.component";
import { BlogComponent } from "./views/blog/blog.component";
import { BlogDetailComponent } from "./views/blog/blog-detail/blog-detail.component";
import { DoctorsListComponent } from "./views/doctor/doctors-list/doctors-list.component";
import { DoctorDetailComponent } from "./views/doctor/doctor-detail/doctor-detail.component";
import { VisitDetailComponent } from "./views/visit/visit-detail/visit-detail.component";
import { AccountInfoComponent } from "./views/admin/account-info/account-info.component";
import { AppointmentListComponent } from "./views/admin/appointment-list/appointment-list.component";
import { UserWalletComponent } from "./views/admin/user-wallet/user-wallet.component";
import { VisitLinkComponent } from "./views/visit/visit-link/visit-link.component";
import { ManageLoginGuard } from "./shared/guards/manageLogin.service";
import { PanelGuard } from "./shared/guards/panelGuard.service";
import { ForbiddenComponent } from "./views/auth/forbidden/forbidden.component";

const routes: Routes = [
  // auth views
  {
    path: "",
    component: AuthComponent,
    children: [
      { path: "", component: LoginComponent },
      { path: "login", component: LoginComponent },
      { path: "register", component: RegisterComponent },
      { path: "forbidden", component: ForbiddenComponent },
      { path: "", redirectTo: "login", pathMatch: "full" },
    ],
    canActivate: [ManageLoginGuard]
  },
  // no layout views
  // { path: "", component: LandingComponent },
  // { path: "profile", component: ProfileComponent },
  // { path: "index", component: IndexComponent },
  // { path: "blog", component: BlogComponent},
  // { path: "blog-detail", component: BlogDetailComponent},
  // { path: "doctors-list", component: DoctorsListComponent},
  // { path: "doctor-detail", component: DoctorDetailComponent},
  // { path: "visit-detail", component: VisitDetailComponent},
  // { path: "visit-link", component: VisitLinkComponent},
  // { path: "**", redirectTo: "", pathMatch: "full" },
  // admin views
  {
    path: "doctor-panel",
    component: AdminComponent,
    children: [{
      path: '',
      loadChildren: () => import('./views/admin/user-layout.module').then(m => m.UserLayoutModule)
    }],
    canActivate: [PanelGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
